const state = {
  // Список
  challenges: [],

  // Общее количество
  total: 0,

  isLoading: false,
};

export default state;
